
@if (view == true) {
  <div class="container">
    <mat-card  appearance="outlined">
      <mat-card-content>
        @if (bodyActividad.created) {
          <div class="d-flex justify-content-end">
            <div>
              <h4 class="m-0 p-0 text-center font-weight-bold" [style]="movil?'font-size: x-small; line-height: 0.6;':''"> Creación Solicitud</h4>
              <h3 class="m-0 p-0 text-center" [style]="movil?'font-size: x-small;':''">{{bodyActividad.created | dateFormat}}</h3>
            </div>
          </div>
        }
        <h2 style="display: flex; justify-content: center;"><strong>Solicitud de Combustible</strong></h2>
        <h3>Equipo: {{bodyActividad.code}}</h3>
        <h3>Fecha ejecucion: {{bodyActividad.date}}</h3>
        <h3 >Solicita: {{bodyActividad.requestName}}</h3>
        <h3 >Medidor actual (horas/km/ciclos): {{bodyActividad.currentOdometer | thousandSeparator}}</h3>
        @if (rol=='Administrativo' || rol =='root' || rol =='Jefe Mantenimiento') {
          <div  style="display: flex; flex-direction: row; justify-content: space-between; margin-top: 30px;">
            <button style="width: 45%;" color="warn" class="button-save mat-elevation-z5 "
            mat-raised-button (click)="response('rechazar')" >Rechazar</button>
            <button type="submit" style="width: 45%;" color="primary" class="button-save mat-elevation-z5 "
            mat-raised-button (click)="response('autorizar')" >Autorizar</button>
          </div>
        }
        @if (rol=='Operario') {
          <div  style="display: flex; flex-direction: row; justify-content: center; margin-top: 30px;">
            <button style="width: 60%;" color="primary" class="button-save mat-elevation-z5 "
            mat-raised-button (click)="edit('editar')" >Editar</button>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </div>
}

@if (view == false && action == 'editar') {
  <div>
    <form [formGroup]="formEdit" (ngSubmit)="formEdit.valid?finalizar(formEdit.value):errorMessage()">
      <div style="width: 100%; display: flex; margin: 30px 0 0 0;">
        <div style='flex:8; margin: 0 15px 0 0;'>
          <div class="row-item">
            <mat-form-field [appOpenDatepickerOnClick]="pickerExecuteDate">
              <mat-label>Fecha ejecucion</mat-label>
              <input matInput [matDatepicker]="pickerExecuteDate" autocomplete="off" matInput
                required formControlName='executionDate' required>
              <mat-datepicker-toggle matIconSuffix [for]="pickerExecuteDate">
              </mat-datepicker-toggle>
              <mat-datepicker #pickerExecuteDate [touchUi]='movil?true:false'></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div style='flex:.2'>
          <button mat-mini-fab color="warn" type="submit">
            <mat-icon>save</mat-icon>
          </button>
          <button mat-mini-fab color="primary" (click)='back()'
            style='margin-top: 10px;'>
            <mat-icon>reply</mat-icon>
          </button>
        </div>
      </div>
    </form>
  </div>
}
